import { useState } from 'react'
import packageInfoVehicleImageBikePerson from '../../../assets/images/thongtingoi_loaixemaycanhan.png'
import packageInfoVehicleImageBikeHome from '../../../assets/images/thongtingoi_loaixemaygiadinh.png'
import packageInfoVehicleImageCarPerson from '../../../assets/images/thongtingoi_loaixeotocanhan.png'
import trafficFineBenefits1 from '../../../assets/images/traffic_fine_benifits_1.png'
import trafficFineBenefits2 from '../../../assets/images/traffic_fine_benifits_2.png'
import trafficFineBenefits3 from '../../../assets/images/traffic_fine_benifits_3.png'
import trafficFineBenefits4 from '../../../assets/images/traffic_fine_benifits_4.png'
import trafficFineBenefits5 from '../../../assets/images/traffic_fine_benifits_5.png'
import trafficFineBenefits6 from '../../../assets/images/traffic_fine_benifits_6.png'
import trafficFineBenefits7 from '../../../assets/images/traffic_fine_benifits_7.png'
import trafficFineBenefits8 from '../../../assets/images/traffic_fine_benifits_8.png'
import trafficFineBenefits9 from '../../../assets/images/traffic_fine_benifits_9.png'
import trafficFineBenefits10 from '../../../assets/images/traffic_fine_benifits_10.png'
import trafficFineBenefits11 from '../../../assets/images/traffic_fine_benifits_11.png'
import trafficFineBenefits12 from '../../../assets/images/traffic_fine_benifits_12.png'
import trafficFineBenefits12V2 from '../../../assets/images/traffic_fine_benifits_12_v2.png'
import trafficFineBenefits13 from '../../../assets/images/traffic_fine_benifits_13.png'
import trafficFineBenefits13V2 from '../../../assets/images/traffic_fine_benifits_13_v2.png'
import trafficFineBenefits14 from '../../../assets/images/traffic_fine_benifits_14.png'
import trafficFineBenefits14V2 from '../../../assets/images/traffic_fine_benifits_14_v2.png'
import './index.scss'
import BaseTitle from '../../BasicComponent/BaseTitle'
import { formatDate } from '../../../helper/formatDate'
import { VEHICLE_TYPE } from '../../../constants/global'
import { LocalStorageManager } from '../../../helper/localStorage'
import { IconArrowDown } from '../../../assets/icons'
import SafeImage from '../../BasicComponent/SafeImage'

const LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY = 'trafficFineLookupV2VehicleType'

export const TRAFFIC_FINE_BENEFITS = [
  {
    key: '1',
    icon: trafficFineBenefits1,
    text: 'Thông báo khi có vi phạm',
    icon2: trafficFineBenefits1,
    text2: 'Thông báo khi có vi phạm'
  },
  {
    key: '2',
    icon: trafficFineBenefits2,
    text: 'Thông báo khi có vi phạm mới',
    icon2: trafficFineBenefits2,
    text2: 'Thông báo khi có vi phạm mới'
  },
  {
    key: '3',
    icon: trafficFineBenefits3,
    text: 'Thông báo phạt nguội',
    icon2: trafficFineBenefits3,
    text2: 'Thông báo phạt nguội'
  },
  {
    key: '4',
    icon: trafficFineBenefits4,
    text: 'Thông báo hạn đăng kiểm',
    icon2: trafficFineBenefits4,
    text2: 'Thông báo hạn đăng kiểm'
  },
  {
    key: '5',
    icon: trafficFineBenefits5,
    text: 'Ưu đãi 30% khi mua BH TNDS',
    icon2: trafficFineBenefits5,
    text2: 'Ưu đãi 30% khi mua BH TNDS'
  },
  {
    key: '6',
    icon: trafficFineBenefits6,
    text: 'Trợ lý tư vấn bảo hiểm',
    icon2: trafficFineBenefits6,
    text2: 'Trợ lý tư vấn bảo hiểm'
  },
  {
    key: '7',
    icon: trafficFineBenefits7,
    text: 'Trợ lý hỗ trợ thủ tục bảo hiểm',
    icon2: trafficFineBenefits7,
    text2: 'Trợ lý hỗ trợ thủ tục bảo hiểm'
  },
  {
    key: '8',
    icon: trafficFineBenefits8,
    text: 'Hỗ trợ gói tín dụng chi phí giao thông',
    icon2: trafficFineBenefits8,
    text2: 'Hỗ trợ gói tín dụng chi phí giao thông'
  },
  {
    key: '9',
    icon: trafficFineBenefits9,
    text: 'Hỗ trợ tặng thẻ tín dụng ưu đãi',
    icon2: trafficFineBenefits9,
    text2: 'Hỗ trợ tặng thẻ tín dụng ưu đãi'
  },
  {
    key: '10',
    icon: trafficFineBenefits10,
    text: 'Hỗ trợ ưu đãi khi mua gói cứu hộ xe máy',
    icon2: trafficFineBenefits10,
    text2: 'Hỗ trợ ưu đãi khi mua gói cứu hộ xe máy'
  },
  {
    key: '11',
    icon: trafficFineBenefits11,
    text: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô',
    icon2: trafficFineBenefits11,
    text2: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô'
  },
  {
    key: '12',
    icon: trafficFineBenefits12,
    text: 'Nhận SMS thông báo tự động 2 tuần một lần',
    icon2: trafficFineBenefits12V2,
    text2: 'Nhận SMS thông báo tự động 2 tuần một lần',
    textIntro: 'Thông báo tự động khi có lỗi phạt mới'
  },
  {
    key: '13',
    icon: trafficFineBenefits13,
    text: 'Cập nhật lịch sử vi phạm và trạng thái xử lý',
    icon2: trafficFineBenefits13V2,
    text2: 'Lịch sử vi phạm và trạng thái xử lý từ Cục Cảnh sát Giao thông',
    textIntro: 'Cập nhật trạng thái xử lý lỗi'
  },
  {
    key: '14',
    icon: trafficFineBenefits14,
    text: 'Tra cứu phạt nguội nhanh và chính xác',
    icon2: trafficFineBenefits14V2,
    text2: 'Tự động nhắc hạn đăng kiểm (sắp ra mắt)',
    textIntro: 'Kiểm tra phạt nguội ngay sau khi đăng ký'
  }
]

const TRAFFIC_FINE_BENEFITS_MAP = TRAFFIC_FINE_BENEFITS.reduce((result, item) => {
  result[String(item.key)] = item
  return result
}, {})

const REGISTERED_PACKAGE_DISPLAY = {
  BIKE_PERSONAL: {
    image: packageInfoVehicleImageBikePerson,
    background: 'linear-gradient(180deg, #EF5859 0%, #FFFFDA 135.4%)'
  },
  BIKE_FAMILY: {
    image: packageInfoVehicleImageBikeHome,
    background: 'linear-gradient(180deg, #F1A01B 0%, #FFE1BE 135.4%)'
  },
  CAR: {
    image: packageInfoVehicleImageCarPerson,
    background: 'linear-gradient(180deg, #28ADEF 21%, #FFDAFD 100%)'
  }
}

function getPackageDisplayByVehicle(vehicleType, productSize) {
  const savedVehicleType = LocalStorageManager.getItem(LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY)
  const safeVehicleType = Number(vehicleType || savedVehicleType) || VEHICLE_TYPE.CAR
  const safeProductSize = Number(productSize)
  const isCar = safeVehicleType === VEHICLE_TYPE.CAR
  const isBike = safeVehicleType === VEHICLE_TYPE.MOTOBIKE || safeVehicleType === VEHICLE_TYPE.ELECTRIC_MOTORBIKE

  if (isCar) {
    return REGISTERED_PACKAGE_DISPLAY.CAR
  }

  if (isBike && safeProductSize > 1) {
    return REGISTERED_PACKAGE_DISPLAY.BIKE_FAMILY
  }

  return REGISTERED_PACKAGE_DISPLAY.BIKE_PERSONAL
}

function pushBenefitItem(result, { key, icon, text }) {
  if (!text) {
    return
  }

  const benefitItem = {
    key,
    text
  }

  if (typeof icon === 'string') {
    benefitItem.iconSrc = icon
  } else if (icon) {
    benefitItem.icon = icon
  }

  result.push(benefitItem)
}

function getBenefitItems(benefits) {
  if (!Array.isArray(benefits)) {
    return []
  }

  return benefits.reduce((result, item) => {
    const isBenefitObject = item && typeof item === 'object' && !Array.isArray(item)
    const benefitKey = isBenefitObject && item.key !== undefined && item.key !== null ? String(item.key) : !isBenefitObject ? String(item) : ''
    const benefitConfig = benefitKey ? TRAFFIC_FINE_BENEFITS_MAP[benefitKey] : null

    if (isBenefitObject) {
      const primaryKey = benefitKey || item.text || `benefit_${result.length + 1}`

      pushBenefitItem(result, {
        key: primaryKey,
        icon: item.icon || item.iconSrc || benefitConfig?.icon || benefitConfig?.iconSrc,
        text: item.text || benefitConfig?.text
      })

      pushBenefitItem(result, {
        key: `${primaryKey}_2`,
        icon: item.icon2 || item.iconSrc2,
        text: item.text2
      })

      return result
    }

    pushBenefitItem(result, {
      key: benefitKey,
      icon: benefitConfig?.icon || benefitConfig?.iconSrc,
      text: benefitConfig?.text
    })

    return result
  }, [])
}

function getOrderPaymentInfo(orderPaymentInfo) {
  if (!orderPaymentInfo) {
    return {}
  }

  if (typeof orderPaymentInfo === 'object' && !Array.isArray(orderPaymentInfo)) {
    return orderPaymentInfo
  }

  try {
    const parsedInfo = JSON.parse(orderPaymentInfo)
    return parsedInfo && typeof parsedInfo === 'object' && !Array.isArray(parsedInfo) ? parsedInfo : {}
  } catch {
    return {}
  }
}

export default function RegisteredPackageInfo({
  className = '',
  productName = '',
  priceText = '',
  priceUnit = '',
  paymentIconUrl = '',
  orderPaymentInfo = '',
  paymentAccountName = '',
  paymentAccountIdentity = '',
  allowRenew = false,
  notifyEndDateTime = '',
  benefits = [],
  defaultExpanded = false,
  alwaysExpanded = false,
  showTitle = true,
  onActionClick,
  vehicleType,
  productSize
}) {
  const [isBenefitsOpen, setIsBenefitsOpen] = useState(defaultExpanded || alwaysExpanded)
  const packageDisplay = getPackageDisplayByVehicle(vehicleType, productSize)
  const benefitItems = getBenefitItems(benefits)
  const parsedOrderPaymentInfo = getOrderPaymentInfo(orderPaymentInfo)
  const isAutoRenew = Number(allowRenew) === 1 || allowRenew === true
  const isBenefitsSectionOpen = alwaysExpanded || isBenefitsOpen
  const expireText = notifyEndDateTime ? formatDate(notifyEndDateTime) : ''
  // const paymentIconSrc = paymentIconUrl?.trim()
  const paymentAccountNameText = (parsedOrderPaymentInfo.paymentAccountName || paymentAccountName || '').trim()
  const paymentAccountIdentityText = (parsedOrderPaymentInfo.paymentAccountIdentity || paymentAccountIdentity || '').trim()
  const actionText = expireText
    ? isAutoRenew
      ? `Gia hạn tự động vào ${expireText}`
      : `Hết hạn vào ${expireText}`
    : isAutoRenew
    ? 'Đang bật gia hạn tự động'
    : 'Chưa bật gia hạn tự động'

  return (
    <div className={`RegisteredPackageInfo ${className}`.trim()}>
      {showTitle ? <BaseTitle>Quản lý gói kiểm tra tự động</BaseTitle> : null}

      <div className="RegisteredPackageInfo_card">
        <div className="RegisteredPackageInfo_cardBackground" style={{ background: packageDisplay.background }}>
          <div className="RegisteredPackageInfo_cardContent">
            <div className="RegisteredPackageInfo_productName">{productName}</div>

            <div className="RegisteredPackageInfo_price">
              <span className="RegisteredPackageInfo_priceValue">{priceText}</span>
              <span className="RegisteredPackageInfo_priceUnit">{priceUnit}</span>
            </div>

            {/* Tạm thời ẩn , khi nào mở lại thì hiển thị */}
            {/* {paymentIconSrc || paymentAccountNameText || paymentAccountIdentityText ? (
              <div className="RegisteredPackageInfo_payment">
                {paymentIconSrc ? (
                  <span className="RegisteredPackageInfo_paymentIcon">
                    <SafeImage src={paymentIconSrc} aria-hidden="true" className="RegisteredPackageInfo_paymentIconImg" />
                  </span>
                ) : null}

                {paymentAccountNameText || paymentAccountIdentityText ? (
                  <div className="RegisteredPackageInfo_paymentTextList">
                    {paymentAccountNameText ? <span className="RegisteredPackageInfo_paymentText">{paymentAccountNameText}</span> : null}
                    {paymentAccountIdentityText ? <span className="RegisteredPackageInfo_paymentText">{paymentAccountIdentityText}</span> : null}
                  </div>
                ) : null}
              </div>
            ) : null} */}
          </div>

          <SafeImage src={packageDisplay.image} aria-hidden="true" className="RegisteredPackageInfo_vehicleImage" />
        </div>

        <div className="RegisteredPackageInfo_cardAction">
          <div className="RegisteredPackageInfo_cardActionText">{actionText}</div>

          <button type="button" className="RegisteredPackageInfo_cardActionButton" onClick={onActionClick}>
            {isAutoRenew ? 'Ngưng gia hạn' : 'Gia hạn tự động'}
          </button>
        </div>
      </div>

      {benefitItems.length ? (
        <div className="RegisteredPackageInfo_benefits">
          <button
            type="button"
            className={`RegisteredPackageInfo_benefitsHeader ${alwaysExpanded ? 'RegisteredPackageInfo_benefitsHeader_static' : ''}`.trim()}
            onClick={alwaysExpanded ? undefined : () => setIsBenefitsOpen((prevState) => !prevState)}
            aria-disabled={alwaysExpanded}
            aria-expanded={isBenefitsSectionOpen}
            tabIndex={alwaysExpanded ? -1 : 0}>
            <span className="RegisteredPackageInfo_benefitsTitle">Quyền lợi gói đang sở hữu</span>
            {!alwaysExpanded ? (
              <IconArrowDown
                className={`RegisteredPackageInfo_benefitsChevron ${isBenefitsSectionOpen ? 'RegisteredPackageInfo_benefitsChevron_expanded' : ''}`.trim()}
              />
            ) : null}
          </button>

          {isBenefitsSectionOpen ? (
            <div className="RegisteredPackageInfo_benefitsBody">
              {benefitItems.map((item) => {
                const Icon = item.icon
                const iconSrc = item.iconSrc

                return (
                  <div key={item.key || item.text} className="RegisteredPackageInfo_benefitItem">
                    <div className="RegisteredPackageInfo_benefitIconWrap">
                      {Icon ? <Icon className="RegisteredPackageInfo_benefitIcon" /> : null}
                      {!Icon && iconSrc ? <SafeImage src={iconSrc} aria-hidden="true" className="RegisteredPackageInfo_benefitIconImage" /> : null}
                    </div>
                    <div className="RegisteredPackageInfo_benefitText">{item.text}</div>
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

